export function ArrayToDictionaryBy(list, key) {
     let r = {};
     if (list && list.length >= 1 && key) {
          list.forEach((listItem) => {
               if (listItem[key] ?? -1 !== -1) {
                    // catch the id
                    r[listItem[key]] = listItem;
               }
          });
     }
     return r;
}
